"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HeaderTabLoader_1 = require("./HeaderTabLoader");
const style_1 = require("./style");
const material_1 = require("@mui/material");
function HeaderTabs({ options, title, onChangeTab, currentTab, isLoading = false, }) {
    const renderOptions = () => {
        return options?.map((option) => {
            return (react_1.default.createElement(style_1.StyledTab, { label: option.label, "data-value": option.value, key: option.label, onClick: option.onClick }));
        });
    };
    return (react_1.default.createElement(style_1.StyledContainer, null,
        react_1.default.createElement(material_1.Container, { maxWidth: "lg" },
            react_1.default.createElement(style_1.Title, { mt: "24px", variant: "h1" }, title),
            isLoading && (react_1.default.createElement("div", { style: { display: "flex", flexWrap: "nowrap", width: "100%" } },
                react_1.default.createElement(HeaderTabLoader_1.HeaderTabLoader, null))),
            !isLoading && (react_1.default.createElement(material_1.Tabs, { value: currentTab, onChange: onChangeTab }, renderOptions())))));
}
exports.default = HeaderTabs;
